/** Local YYYY-MM-DD, without converting through UTC. */
export const localDateString = (value) => {
    const d = new Date(value);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const startOfLocalDay = (value) => {
    const d = new Date(value);
    d.setHours(0, 0, 0, 0);
    return d;
};

export const endOfLocalDay = (value) => {
    const d = new Date(value);
    d.setHours(23, 59, 59, 999);
    return d;
};

export const queryRangeIso = (startDate, endDate) => ({
    start: startOfLocalDay(startDate).toISOString(),
    end: endOfLocalDay(endDate).toISOString(),
});

/** Preset ranges used by Home and Audience: local calendar days, inclusive. */
export const applyDashboardTimeframe = (option) => {
    const endDate = endOfLocalDay(new Date());
    const startDate = startOfLocalDay(new Date());

    switch (option) {
        case '30days':
            startDate.setDate(startDate.getDate() - 30);
            break;
        case '90days':
            startDate.setDate(startDate.getDate() - 90);
            break;
        case '6months':
            startDate.setMonth(startDate.getMonth() - 6);
            break;
        case '1year':
            startDate.setFullYear(startDate.getFullYear() - 1);
            break;
        case 'yeartodate':
            startDate.setMonth(0, 1);
            break;
        case 'monthtodate':
            startDate.setDate(1);
            break;
        case 'lastmonth': {
            const lastMonthEnd = startOfLocalDay(new Date());
            lastMonthEnd.setDate(0);
            lastMonthEnd.setHours(23, 59, 59, 999);
            const lastMonthStart = startOfLocalDay(lastMonthEnd);
            lastMonthStart.setDate(1);
            return { startDate: lastMonthStart, endDate: lastMonthEnd };
        }
        default:
            startDate.setDate(startDate.getDate() - 30);
            break;
    }

    return { startDate, endDate };
};
